import script from "./ProjectClientsExpandModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectClientsExpandModal.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectClientsExpandModal.vue?vue&type=style&index=0&id=0cfae459&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cfae459"]])

export default __exports__